import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { clientOutModel } from '../model/index';

@Injectable()
export class clientOutService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private clientOutUrl = 'api/clientOut';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    addClientOut(clientOutData: any): Promise<clientOutModel> {
        let url = "";
        if(clientOutData['mode'] == 'Edit'){
             url = `${this.clientOutUrl}/editClientOut`;
        }else{
             url = `${this.clientOutUrl}/addClientOut`;
        }

        // Check if clientOutData is FormData (for file uploads)
        if (clientOutData instanceof FormData) {
            // For FormData, don't use $.param() and don't set Content-Type header
            // Browser will automatically set it with proper boundary
            return this.http
                .post(url, clientOutData)
                .toPromise()
                .then(res => res.json() as clientOutModel)
                .catch(this.handleError);
        } else {
            // For regular data, use URL-encoded format
            return this.http
                .post(url, $.param(clientOutData), { headers: this.headers })
                .toPromise()
                .then(res => res.json() as clientOutModel)
                .catch(this.handleError);
        }
    }

    getPendingOutStatusReport(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.clientOutUrl}/getPendingOutStatusReport`, options)
            .toPromise().then(this.extractData).catch(err => [JSON.parse(err._body)]);
    }

    getPageTypes(): Promise<any> {
        return this.http.get(`${this.clientOutUrl}/getPendingOutStatusPageTypes`, { headers: this.headers })
            .toPromise().then(this.extractData).catch(err => [JSON.parse(err._body)]);
    }

    sendPendingOutStatusEmail(data: any): Promise<any> {
        return this.http.post(`${this.clientOutUrl}/sendPendingOutStatusEmail`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(err => [JSON.parse(err._body)]);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/clientOut.service.ts